import React, { createContext, useState, useCallback } from "react";
import type { ReactNode } from "react";

export interface LoginModalContextType {
  isLoginOpen: boolean;
  openLoginModal: () => void;
  closeLoginModal: () => void;
}

export const LoginModalContext = createContext<LoginModalContextType | undefined>(undefined);

export const LoginModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const openLoginModal = useCallback(() => setIsLoginOpen(true), []);
  const closeLoginModal = useCallback(() => setIsLoginOpen(false), []);

  return (
    <LoginModalContext.Provider value={{ isLoginOpen, openLoginModal, closeLoginModal }}>
      {children}
    </LoginModalContext.Provider>
  );
};
